import { streamingRestApi } from '@/service/streamingApi'
import { Whitelisting } from '@/types/streams/whitelisting'

import { createBaseTableStore } from '../table'
import { FetchApiArgs, FetchApiResponse } from '../table/table.types'

const fetchWhitelistApi = async (args: FetchApiArgs): Promise<FetchApiResponse<Whitelisting>> => {
  const { signal } = args

  const { data } = await streamingRestApi.endpoints.whitelist.getWhitelist(signal)

  return {
    content: data,
    totalElements: data.length
  }
}

export const useWhitelistingStore = createBaseTableStore<Whitelisting>({
  storeName: 'DGE Whitelisting',
  fetchApi: fetchWhitelistApi
})
